import { Reveal } from "./Reveal";
import { COACH_IMAGE } from "../../constants/site";

export const Creator = () => (
    <section className="relative bg-ivory py-16 sm:py-24" data-testid="creator-section">
        <div className="mx-auto grid max-w-5xl grid-cols-1 items-center gap-12 px-5 sm:px-8 lg:grid-cols-12 lg:gap-16">
            <Reveal className="flex justify-center lg:col-span-5 lg:justify-start">
                <div className="relative w-64 sm:w-72" data-testid="creator-portrait-frame">
                    <div
                        aria-hidden
                        className="absolute -inset-3 -translate-x-3 translate-y-3 rounded-b-[2rem] rounded-t-[10rem] border border-gold/50"
                    />
                    <div className="relative overflow-hidden rounded-b-[2rem] rounded-t-[10rem] shadow-xl shadow-plum/20">
                        <img
                            src={COACH_IMAGE}
                            alt="Warm portrait of the creator of the 5-Day Husband Reset Guide"
                            className="aspect-[4/5] w-full object-cover"
                            data-testid="creator-portrait"
                        />
                    </div>
                </div>
            </Reveal>

            <div className="lg:col-span-7">
                <Reveal>
                    <p className="mb-4 font-sans text-[0.65rem] font-bold uppercase tracking-[0.28em] text-gold">
                        From the Creator
                    </p>
                    <h2 className="max-w-xl font-serif text-2xl font-medium leading-snug text-plum sm:text-3xl lg:text-4xl">
                        Created For Women Who Want{" "}
                        <em className="italic text-burgundy">Connection &mdash; Not Perfection.</em>
                    </h2>
                </Reveal>

                <Reveal delay={0.1}>
                    <blockquote className="mt-8 border-l-2 border-gold/60 pl-6" data-testid="creator-quote">
                        <span aria-hidden className="block font-serif text-5xl leading-none text-gold/50">
                            &ldquo;
                        </span>
                        <p className="text-base leading-relaxed text-mutedtext sm:text-lg">
                            I created this guide for women who are managing so much every day &mdash; work, home,
                            family and relationships &mdash; and sometimes forget to pause and understand what is
                            happening inside their own relationship.
                        </p>
                        <p className="mt-4 text-base leading-relaxed text-mutedtext sm:text-lg">
                            You don&rsquo;t have to become a different person. Sometimes you simply need to understand
                            the pattern and make one small shift at a time.
                        </p>
                    </blockquote>
                </Reveal>

                <Reveal delay={0.18}>
                    <div className="mt-8" data-testid="creator-name-block">
                        <p className="font-serif text-xl font-medium text-plum" data-testid="creator-name">
                            Dipa M Kapur
                        </p>
                        <p className="mt-1 font-sans text-[0.65rem] font-bold uppercase tracking-[0.26em] text-gold">
                            Relationship Energy Coach
                        </p>
                    </div>
                </Reveal>
            </div>
        </div>
    </section>
);

export default Creator;
